export const actionKeys = {
  BUY: "buy",
  DOWNLOAD: "download",
  LISTEN: "listen",
  WATCH: "watch",
  PLAY: "play",
  ENROLL: "enroll",
  READ: "read",
  LEARN: "learn",
  LOOKUP: "lookup",
  USE: "use",
  STUDY: "study",
  JOIN: "join",
  ATTEND: "attend",
  CONTACT: "contact",
  LINKS: "links",
  SIGN: "sign",
  WRITE: "write",
} as const

export type ActionKey = (typeof actionKeys)[keyof typeof actionKeys]
